import { LanguageFilterJson } from '@ninjacart/nc-nk-store';
import { Paragraph, XStack } from '@ninjacart/nc-nk-ui';
import { ChevronDown } from '@tamagui/lucide-icons';
import { useEffect } from 'react';
import { useQnaFeedStore } from '../../store/useQnaStore';

export function LanguageButton({ theme, onOpenLanguageFilter, t }) {
  const languageFilterName = useQnaFeedStore((state) => state.languageFilterName);
  const languageFilterValue = useQnaFeedStore((state) => state.languageFilterValue);
  const setLanguageFilterName = useQnaFeedStore((state) => state.setLanguageFilterName);

  useEffect(() => {
    const languageLabel = LanguageFilterJson.find((lang) => lang.value === languageFilterValue);
    setLanguageFilterName(languageLabel?.name!);
  },[languageFilterValue]);

  
  return (
    <XStack
      borderWidth={1}
      borderRadius={10}
      paddingHorizontal={12}
      paddingVertical={8}
      borderColor={'$qnaLanguageDropDownBorderClr'}
      alignItems="center"
      margin={10}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      onPress={onOpenLanguageFilter}
      maxWidth="80%"
      alignSelf="flex-start"
    >
      <Paragraph fontSize={16} color={'$color'} fontWeight="500" flexShrink={1}>
        {t('page.language')} {languageFilterName ? `- ${languageFilterName}` : ''}
      </Paragraph>
      <ChevronDown size={24} color={theme['qnaLanguageDropDownBorderClr']?.val} />
    </XStack>
  );
}